import { createSlice } from "@reduxjs/toolkit";
import { sessionService } from "redux-react-session";
import ReactGA from "react-ga4";
import { BASE_API_URL } from "../constants";
import { runUnauthorizedActions } from "features/account/loginSlice";
import { getMatchingItems } from "features/functions";

const initialState = {
	isLoading: false,
	value: "",
	selectedItem: {},
	suggestions: [],
	list: null,
};

const vehicleBrands = createSlice({
	name: "vehicleBrands",
	initialState,
	reducers: {
		requestVehicleBrandsList(state) {
			state.isLoading = true;
		},
		receiveVehicleBrandsList(state, action) {
			state.isLoading = false;
			state.list = action.payload.list;
		},
		loadVehicleBrandsSuggestionsBegin(state) {
			state.isLoading = true;
		},
		maybeUpdateVehicleBrandsSuggestions(state, action) {
			state.isLoading = false;
			if (state.value !== action.payload.value) {
			} else {
				state.suggestions = action.payload.suggestions;
			}
		},
		updateVehicleBrandValue(state, action) {
			state.value = action.payload.value;
		},
		updateVehicleBrandItem(state, {payload}) {
			if (payload.selectedItem?.Name != null) {
				ReactGA.event({
					category: "Vehiculo",
					action: "Seleccionar Marca",
					label: payload.selectedItem.Name,
					value: payload.selectedItem.ID,
				});
			}
			state.selectedItem = payload.selectedItem;
		},
		clearVehicleBrandsSuggestions(state) {
			state.suggestions = [];
		},
		clearVehicleBrandValue(state) {
			state.value = "";
			state.selectedItem = {};
		},
		clearVehicleBrandData: () => initialState,
	},
});

export const {
	requestVehicleBrandsList,
	receiveVehicleBrandsList,
	loadVehicleBrandsSuggestionsBegin,
	maybeUpdateVehicleBrandsSuggestions,
	updateVehicleBrandValue,
	updateVehicleBrandItem,
	clearVehicleBrandsSuggestions,
	clearVehicleBrandValue,
	clearVehicleBrandData,
} = vehicleBrands.actions;

const shouldFetchVehicleBrands = (state) => {
	if (state.vehicleBrands.list == null) {
		return true;
	}
	return false;
};
export const fetchVehicleBrandsIfNeeded = () => async (dispatch, getState) => {
	if (shouldFetchVehicleBrands(getState())) {
		return dispatch(fetchVehicleBrands());
	}
};
export const loadVehicleBrandsSuggestions = (value) => async (
	dispatch,
	getState
) => {
	dispatch(loadVehicleBrandsSuggestionsBegin());
	dispatch(fetchVehicleBrandsIfNeeded());
	const theState = getState();
	setTimeout(() => {
		dispatch(
			maybeUpdateVehicleBrandsSuggestions({
				suggestions: getMatchingItems(theState.vehicleBrands, value),
				value,
			})
		);
	});
};
export const fetchVehicleBrands = () => async (dispatch) => {
	sessionService
		.loadSession()
		.then((session) => {
			const headers = {
				Authorization: "bearer " + session.loginData.access_token,
				"Content-Type": "application/json",
			};
			const options = {
				method: "GET",
				headers: headers,
			};
			dispatch(requestVehicleBrandsList());
			let responseStatus = 0;
			return fetch(
				BASE_API_URL + "/api/FamilyFriends/Vehiculos/Buscar/Marcas",
				options
			)
				.then((response) => {
					responseStatus = response.status;
					if (response.ok) {
						return response.json();
					} else {
						return Promise.reject("Ocurrió un error");
					}
				})
				.then((json) => {
					dispatch(receiveVehicleBrandsList({ list: json }));
				})
				.catch((error) => {
					// TODO: fetch error actions
					// If 401 Unauthorized login failed
					if (responseStatus === 401) {
						dispatch(runUnauthorizedActions());
					}
				});
		})
		.catch((err) => console.log("Error", err));
};

export default vehicleBrands.reducer;
